module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "data-qa": "Content-TimelineLog-Body"
    }
  }, [_vm._l((_vm.logList), function(item, index) {
    return _c('el-row', {
      key: index,
      staticClass: "log-list",
      attrs: {
        "gutter": 20
      }
    }, [_c('el-col', {
      attrs: {
        "data-qa": ("Content-TimelineLogType-Column-" + index),
        "span": 3
      }
    }, [_c('el-tag', {
      attrs: {
        "type": _vm.logType(item.type).color
      }
    }, [_vm._v(_vm._s(_vm.logType(item.type).label))])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "data-qa": ("Content-TimelineLogDescribe-Column-" + index),
        "span": 10
      }
    }, [_c('b', [_vm._v(_vm._s(item.action.label))]), (item.action.content || item.action.notification) ? _c('b', [_vm._v(": ")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getContent(item.action)))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.moreMessage(item.action)))]), _vm._v(" "), (item.action.conditions) ? _c('span', [_vm._v(_vm._s(_vm.getConditionStatus(item.action.conditions)))]) : _vm._e(), _vm._v(" "), _c('router-link', {
      staticClass: "from-who",
      attrs: {
        "data-qa": ("Content-TimelineLogFromWho-Link-" + index),
        "to": _vm.navigate(item),
        "replace": ""
      },
      on: {
        "click": function($event) {
          _vm.hideModel()
        }
      }
    }, [_vm._v(_vm._s(_vm.fromWhom(item)))])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "data-qa": ("Content-TimelineLogViewInfo-Column-" + index),
        "span": 4
      }
    }, [(_vm.status[index]) ? _c('el-tooltip', {
      attrs: {
        "placement": "top"
      }
    }, [_c('div', {
      staticClass: "status-tooltip",
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [(item.type !== 'debug') ? _c('el-row', [_c('el-col', [_c('b', [_vm._v(_vm._s(_vm.$t('timelineLogTooltipLocationText')) + ": " + _vm._s(_vm.status[index].regionName) + ", " + _vm._s(_vm.status[index].countryName) + " (" + _vm._s(_vm.status[index].ip) + ")")])])], 1) : _vm._e(), _vm._v(" "), _c('el-row', _vm._l((_vm.status[index].content), function(value, key) {
      return _c('el-col', {
        key: key,
        attrs: {
          "span": 6
        }
      }, [_vm._v("\n              " + _vm._s(key) + ": " + _vm._s(value) + "\n            ")])
    }))], 1), _vm._v(" "), _c('a', {
      staticClass: "view-info",
      attrs: {
        "data-qa": ("Content-TimelineLogViewInfo-Link-" + index)
      },
      on: {
        "mouseover": function($event) {
          _vm.getInfo(index, item.identity, item.time, item.ip, item.action.device_unique_id)
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.$t('timelineLogLinkViewInfoText')) + "\n        ")])]) : _c('a', {
      staticClass: "view-info",
      attrs: {
        "data-qa": ("Content-TimelineLogViewInfo-Link-" + index)
      },
      on: {
        "mouseover": function($event) {
          _vm.getInfo(index, item.identity, item.time, item.ip, item.action.device_unique_id)
        }
      }
    }, [_vm._v("\n        " + _vm._s(_vm.$t('timelineLogLinkViewInfoText')) + "\n      ")])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "data-qa": ("Content-TimelineLogTime-Column-" + index),
        "span": 7
      }
    }, [_vm._v("\n      " + _vm._s(_vm._f("formatDate")(item.time)) + "\n    ")])], 1)
  }), _vm._v(" "), (_vm.isEmpty) ? _c('div', {
    staticClass: "empty-message",
    attrs: {
      "data-qa": "Content-TimelineLog-Empty"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('timelineLogEmptyMessage')) + "\n  ")]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-202b2f92","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TimelineLog/TimelineLog.vue
// module id = 956
// module chunks = 3